<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addLark"
  >
    <lark-form
      ref="form"
      @submit="submitHandle"
    ></lark-form>
  </sliderBarDialogShell>
</template>

<script>
import larkForm from '@/components/sys/robitCofig/lark/larkForm'
import {saveLarkConfig} from "@/api/sys/robitConfig/lark";

export default {
  name: 'addLark',
  components:{
    larkForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: '新增Lark应用',
    }
  },
  methods: {
    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        saveLarkConfig(formData).then((res) => {
            this.$refs.form.$refs.form.clearValidate();
                this.$refs.form.$refs.form.resetFields();
            this.$emit('add-success');
            this.$refs.form.reset();
        })
    }
  }
}
</script>

<style lang="scss">
@media screen and (min-width: 768px) {
  .addLark.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
